<script>
export default {

    props: {
        optionName: {
            type: String,
            required: true
        },
        iconName: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        bottom: {
            type: String,
            required: false,
            default: '64'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        emitClick() {
            this.$emit('selliaOptionBuilderClick' + this.id.charAt(0).toUpperCase() + this.id.slice(1))
        }
    }
}
</script>

<template>
    <button 
        :id="`sellia-option-builder-${id}`" 
        :ref="`sellia-option-builder-${id}`"
        @click="emitClick()"
        class="sellia-option-builder rounded-pill mx-auto position-absolute zi-10 end-20 border-0"
        :style="{ bottom: bottom + 'px' }"
        :disabled="disabled"
        :class="{ 'disabled': disabled }"
    >
        <div class="d-flex align-items-center justify-content-between px-2-5 py-2 gap-2">
            <Tooltip :title="optionName" placement="top">
                <component 
                    :is="`Icon${iconName}`" 
                    color="#6260F0" 
                    hoverColor="#C86FE7" 
                    size=16
                />
            </Tooltip>
            <h3 class="lh-18 fs-8 mb-0">{{ optionName }}</h3>
        </div>
    </button>
</template>

<style>
.sellia-option-builder {
    background-color: #E1E4FF !important;
    color: #6260F0 !important;
}

.sellia-option-builder:hover {
    background-color: #FBE5F8 !important;
    color: #C86FE7 !important;
}

.sellia-option-builder:hover path {
    fill: #C86FE7 !important;
}

.px-2-5 {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
}

.lh-18 {
    line-height: 18px !important;
}

.fs-8 {
    font-size: 12px !important;
}

.end-20 {
    right: 20px !important;
}

.gap-2 {
    gap: 0.5rem !important;
}

.zi-10 {
    z-index: 10 !important;
}

.disabled {
    cursor: not-allowed !important;
}
</style>
